import React, {Component} from 'react';
import styled from 'styled-components';
import Tabela, {TabelaLinha as TL} from '../Common/Tabela'
import CelulaHeader from '../Common/CelulaHeader'
import Celula from '../Common/Celula'
import {orderBy} from 'lodash-es';
import {mascCPF, mascCNPJ} from '../Helpers/mascara'
import Empregados from '../App/Empregados'
import Drawer from '../App/Drawer'
import {
  mutate,
  Consumer,
  Provider,
} from '../Data/selected'
import { useState } from 'react';

const TabelaLinha = styled(TL)`
  grid-template-columns: 40px 170px 390px 100px 122px 72px 190px;
`

class Empresas extends Component {
  state = { sortBy: "Codigo", desc: false }
  setSort = (idx) => () => {
    this.setState(state => {
      let desc = (state.sortBy === idx) ? !state.desc : false
      return { sortBy: idx, desc }
    })
  }
  render() {
    const { sortBy, desc } = this.state;
    const { data, dialog } = this.props;
    const { empresas } = data;
    let order = desc ? "desc" : "asc"
    let list = orderBy(empresas, [sortBy], [order])
    return (
      <Provider>
        <EmpresasUI
          dialog={dialog}
          list={list}
          sort={{
            set: this.setSort,
            sortBy, desc
          }}
        />
      </Provider>
    )
  }
}

const format = s => {
  if (!s) return ""
  if (s.length === 14) return mascCNPJ(s)
  if (s.length === 11) return mascCPF(s)
  return s
}

const EmpresasUI = props => {
  const { list, sort } = props;
  const [ drawer, setDrawer ] = useState(false);
  const [ dialog, setDialog ] = useState(false);
  const fields = [
    ["Codigo", "Cod"],
    ["Apelido", "Apelido"],
    ["RazaoSocial", "Razão Social"],
    ["Cidade", "Cidade"],
    ["CNPJ", "CNPJ/CPF", format],
    ["Telefone", "Telefone"],
    ["Email", "E-mail"],
  ]


  return (
    <Consumer select={[state => state.empresa]}>
    {empresa => (
      <>
      <Drawer
        drawer={drawer}
        setDrawer={setDrawer}
        setDialog={setDialog}
        empresa={empresa}
      />
      <Tabela>
        <TabelaLinha header>
        {fields.map((f,i) => (
          <CelulaHeader key={"a"+i} field={f} sort={sort}/>
        ))}
        </TabelaLinha>
        {list.map((empr,i0) => (
          <TabelaLinha key={"b"+i0} onDoubleClick={() => {
            mutate(s=> {
              s.empresa.id = empr.Codigo
              s.empresa.data = empr
            })
            setDrawer(true)
          }}>
            {fields.map((f,i1) => (<Celula key={"c"+i0+i1}>{f[2] ? f[2](empr[f[0]]) : empr[f[0]]}</Celula>))}
          </TabelaLinha>
        ))}
      </Tabela>
      <Empregados
        dialog={dialog}
        setDialog={setDialog}
        empresa={empresa}
      />
      </>
    )}
    </Consumer>
  )
}

export default Empresas
